import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Polls the ticket show page to detect when AI triage completes.
// Auto-refreshes via Turbo visit when the triage banner is no longer needed.
// data-controller="support--triage-poll"
export default class extends Controller {
  static values = {
    ticketId: String,
    url: String,
  }

  connect() {
    this.pollCount = 0
    this.maxPolls = 20 // Stop after ~60 seconds (20 × 3s)
    this.timer = setInterval(() => this.#poll(), 3000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  async #poll() {
    this.pollCount++

    if (this.pollCount >= this.maxPolls) {
      clearInterval(this.timer)
      return
    }

    try {
      const response = await get(this.urlValue, {
        responseKind: "html",
      })

      if (!response.ok) return

      const html = await response.html

      // If the response no longer contains the pending triage banner, reload
      if (!html.includes('data-controller="support--triage-poll"')) {
        clearInterval(this.timer)
        window.Turbo?.visit(window.location.href, { action: "replace" })
      }
    } catch {
      // Network error — skip this poll
    }
  }
}
